import DateTimePicker from '../../components/controls/DateTimePicker/DateTimePicker';
import FormCommand from '../../components/controls/FormCommand/FormCommand';
import classes from './loan-summary-report-page.module.css';

export interface LoanSummaryReportPageProps { }

function LoanSummaryReportPage(props: LoanSummaryReportPageProps) {

	return (
		<div className='row'>
			<div className="col">
				<fieldset className='section section-primary'>
					<div className="row">
						<div className="col">
							<DateTimePicker id='startDate' text='Start Date' type='date' />
						</div>
						<div className="col">
							<DateTimePicker id='endDate' text='End Date' type='date' />
						</div>
					</div>

				</fieldset>
				<FormCommand commandText='Preview' />
			</div>
		</div>
	);
}

export default LoanSummaryReportPage;